// pages/FormViewerPage/services/formViewerService/funnelTiktok.ts — event funnel TikTok (split dari funnelEvents.ts)
import type { FunnelEventParams } from './funnelTypes';
import { alreadyFired } from './funnelSession';

// Tembak event funnel TikTok (ttq) — idempoten per sesi tab.
export function fireFunnelTiktokEvent(
    pixelIds: string[],
    eventName: 'AddToCart' | 'InitiateCheckout',
    params: FunnelEventParams,
    sessionKey: string
): boolean {
    try {
        if (!pixelIds || pixelIds.length === 0) return false;
        if (alreadyFired(sessionKey)) return false;
        const w = window as any;
        const ttq = w.ttq;
        // SDK belum siap → coba 1x lagi 2,5 dtk (interaksi user biasanya belakangan).
        if (!ttq || typeof ttq.instance !== 'function') {
            setTimeout(() => fireFunnelTiktokEvent(pixelIds, eventName, params, sessionKey), 2500);
            return false;
        }
        for (const id of pixelIds) {
            const t = id?.trim();
            if (!t) continue;
            try {
                if (!ttq._i || !ttq._i[t]) ttq.load(t);
                ttq.instance(t).track(eventName, {
                    content_type: 'product',
                    currency: 'IDR',
                    ...(params.content_ids ? { content_ids: params.content_ids } : {}),
                    ...(params.content_name ? { content_name: params.content_name } : {}),
                    ...(params.value !== undefined ? { value: params.value } : {}),
                });
            } catch { /* abaikan per pixel */ }
        }
        return true;
    } catch { return false; }
}
